import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/tech-trends/on-thi-jpd113/OnThiJPD113Client.tsx");
